import { Styles } from "@mcleod/core";

export const IFrameStyles = Styles.make("ifr", () => {
    return {
        base: {
            borderWidth: 0,
            width: "100%",
            height: "100%"
        },
    };
});
